/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */

import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { fetchCommonFilters } from '../../../../api/reports';
import { MultiSelect } from '../../../../common/components';
import { useSetLoading } from '../../../../common/hooks/appearance';
import { generateDefaultMultiSelect } from '../../../../common/hooks/data';
import {
  agreementNeedTypeLabels,
  commonMultiSelectFiltersPrefixedData,
  TrustEntities,
} from '../../../../utils/constant';
import { apiErrorHandler } from '../../../../utils/handlers';

const DetailedContractFilters = ({ page, setShowTable, setApplyFilters }) => {
  // const [filters, setFilters] = useState(initialFilters);
  const [filters, setFilters] = useState([]);
  const [commonFilters, setCommonFilters] = useState(commonMultiSelectFiltersPrefixedData);
  const [loading, setLoading] = useState(false);

  const fetchCommonFiltersData = async () => {
    const commonFiltersData = { ...commonFilters };
    setLoading(true);
    try {
      const res = await fetchCommonFilters({
        ...(page === 'journals' && { journal: 'true' }),
        type: 'all',
      });

      // Entity Processing
      commonFiltersData.entity = [
        ...commonFiltersData.entity,
        ...TrustEntities,
        ...res.data.data.locations.map((item) => {
          // if(item.name === 'Cypress Lawn') item.name = 'Cypress Lawn Funeral'

          return {
            label: item.name,
            value: item.id,
          };
        }),
      ];
      // BusinessUnit Processing
      commonFiltersData.businessUnits = [
        ...commonFiltersData.businessUnits,
        ...res.data.data.units.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        }),
      ];
      // Agreement Type Processing
      commonFiltersData.agreementTypes = [
        ...commonFiltersData.agreementTypes,
        ...res.data.data.needs.map((item) => {
          return {
            label: agreementNeedTypeLabels[item?.name] || item?.name,
            value: item.id,
          };
        }),
      ];
      // Store in Local CommonFilterState after Processing
      setCommonFilters(commonFiltersData);
      // Multi Select changes
      setFilters({
        entity: commonFiltersData.entity.map((e) => e.value),
        agreementTypes: commonFiltersData.agreementTypes.map((e) => e.value),
        businessUnits: commonFiltersData?.businessUnits.map((e) => e.value),
        teams: commonFiltersData?.teams.map((e) => e.value),
        reportingManagers: commonFiltersData?.reportingManagers.map((e) => e.value),
        saleTypes: commonFiltersData?.saleTypes.map((e) => e.value),
      });
      generateDefaultMultiSelect({
        entity: commonFiltersData.entity.map((e) => e.value),
        agreementTypes: commonFiltersData.agreementTypes.map((e) => e.value),
        businessUnits: commonFiltersData?.businessUnits.map((e) => e.value),
        teams: commonFiltersData?.teams.map((e) => e.value),
        reportingManagers: commonFiltersData?.reportingManagers.map((e) => e.value),
        saleTypes: commonFiltersData?.saleTypes.map((e) => e.value),
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      apiErrorHandler(err);
    }
  };

  useEffect(() => {
    fetchCommonFiltersData();
  }, []);

  const handleFilters = (filterType, value) => {
    setShowTable((data) => ({ ...data, [filterType]: value }));
    setApplyFilters(true);
    setFilters({
      ...filters,
      [filterType]: value,
    });
  };

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <div className="account-trust">
      <Row className="trust-type ">
        <Col>
          <MultiSelect
            name="businessUnits"
            formInput={false}
            label="BUSINESS UNIT"
            placeholder="Multiple Selections"
            onChange={(val) => {
              handleFilters('businessUnits', val);
            }}
            value={filters?.businessUnits}
            options={commonFilters?.businessUnits}
            disableSearch
          />
        </Col>
        <Col>
          <MultiSelect
            name="Entity"
            formInput={false}
            placeholder="Multiple Selections"
            label="ENTITY"
            onChange={(val) => {
              handleFilters('entity', val);
            }}
            value={filters?.entity}
            options={commonFilters?.entity}
            disableSearch
          />
        </Col>
        <Col>
          <MultiSelect
            name="agreementTypes"
            formInput={false}
            placeholder="Multiple Selections"
            label="Agreement Need Type"
            onChange={(val) => {
              handleFilters('agreementTypes', val);
            }}
            value={filters?.agreementTypes}
            options={commonFilters?.agreementTypes}
            disableSearch
          />
        </Col>
      </Row>
      <hr />
    </div>
  );
};

DetailedContractFilters.propTypes = {
  page: PropTypes.string,
};

DetailedContractFilters.defaultProps = {
  page: '',
};

export default DetailedContractFilters;
